import { render, staticRenderFns } from "./wxpay2.vue?vue&type=template&id=17905432&scoped=true"
import script from "./wxpay2.vue?vue&type=script&lang=js"
export * from "./wxpay2.vue?vue&type=script&lang=js"
import style0 from "./wxpay2.vue?vue&type=style&index=0&id=17905432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17905432",
  null
  
)

export default component.exports